<template>
    <div class="card">
        <DataTable
            :value="allGroups"
            :lazy="true"
            :paginator="true"
            :first="params.page * params.page_size - params.page_size"
            :rows="params.page_size"
            ref="dt"
            dataKey="id"
            :totalRecords="totalRecords"
            :loading="loading"
            @page="onPage($event)"
            responsiveLayout="scroll"
            :rowsPerPageOptions="[5, 10, 20, 50, 100]"
            paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
        >
            <template #empty> No Groups Available. </template>

            <Column field="id" header="SN" ref="id" />
            <Column field="code" header="CODE" ref="code" />
            <Column field="description" header="DESCRIPTION" ref="description" />
            <Column v-if="authStore.hasPermission(UserPermission.READ_GROUPS)" field="permissions" header="PERMISSIONS" ref="permissions">
                <template #body="slotProps">
                    <span class="p-column-title">PERMISSIONS</span>
                    <Button :label="`${slotProps.data.permissions?.length}`" icon="pi pi-tags" class="mr-2 mb-2" @click="toggleDialogTable(slotProps.data.code, slotProps.data.permissions)"></Button>
                </template>
            </Column>
            <Column v-if="authStore.hasPermission(UserPermission.READ_PERMISSION_USER)" field="users_list" header="GROUP USERS" ref="group_users">
                <template #body="slotProps">
                    <span class="p-column-title">GROUP USERS</span>
                    <Button icon="pi pi-user" label="Users" class="m-2 p-button p-button-warning text-black" v-tooltip="'Show Group Users'" @click="toggleDialogTable(slotProps.data.code, [], slotProps.data.id)"> </Button>
                </template>
            </Column>
            <Column field="created_at" header="CREATED AT" ref="created_at" />

            <Column field="actions" header="ACTIONS" style="min-width: 8rem">
                <template #body="slotProps">
                    <Button v-if="authStore.hasPermission(UserPermission.WRITE_GROUPS)" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editGroupDetails(slotProps.data.id)" v-tooltip="'Edit User Group'" />
                    <Button v-if="authStore.hasPermission(UserPermission.DELETE_GROUPS)" icon="pi pi-trash" class="p-button-rounded p-button-danger" @click="confirmRequest(slotProps.data, groupStore.deleteGroup)" v-tooltip="'Delete User Group'" />
                </template>
            </Column>
        </DataTable>

        <!-- Dialog for PermissionLists as well as for GroupUsers table -->
        <!-- The loader applies only incase of users since it has async await calls -->
        <Dialog v-model:visible="dialog.visible" :style="{ width: '500px' }" :loading="dialog.content === 'users' ? usersLoading : false" :modal="true" class="p-fluid dialog-header">
            <!-- Dialog header -->
            <template #header>
                <h5>{{ dialog.header }}</h5>
            </template>
            <group-permissions-table v-if="dialog.content === 'permissions'" :permission-list="dialog.data" />
            <group-users-table v-else :group-users="dialog.data" />
        </Dialog>

        <!-- Edit Group Dialog -->
        <group-form v-if="editGroupDialog" mode="edit" @hide-dialog="editGroupDialog = false" />
    </div>
</template>

<script setup>
import GroupPermissionsTable from './GroupPermissionsTable.vue';
import GroupUsersTable from './GroupUsersTable.vue';
import GroupForm from './GroupForm.vue';
import { ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { authStore, groupStore } from '../../../store/global-stores';
import { UserPermission } from '../../permission/enum';
import { useConfirmRemove } from '@/composables/ConfirmComposable';

const { allGroups, params, loading, usersLoading, totalRecords } = storeToRefs(groupStore);
const { confirmRequest } = useConfirmRemove();

//  dialog details
const dialog = ref({
    visible: false,
    header: null,
    content: null,
    loading: false,
    data: null,
});

// edit group
const editGroupDialog = ref(false);

onMounted(async () => {
    await loadGroups(params.value);
});

const loadGroups = async (params) => {
    await groupStore.getAllGroups(params, true);
};

const onPage = async (event) => {
    const newParams = {
        page_size: event.rows,
        page: event.page + 1,
    };
    // params.value.page_size = event.rows;
    // by default event.page starts from 0 so we will add 1
    // params.value.page = event.page + 1;
    await loadGroups(newParams);
};

// toggles datatable for Permissions and GroupUsers for group
const toggleDialogTable = async (code, permissions = null, groupId = null) => {
    if (groupId) {
        dialog.value = {
            visible: true,
            header: 'List of Users in ' + code,
            content: 'users',
            data: await groupStore.fetchGroupUsers(groupId),
        };
    } else {
        dialog.value = {
            visible: true,
            header: 'List of permissions in ' + code,
            content: 'permissions',
            data: permissions,
        };
    }
};

// setup group for editing its details
const editGroupDetails = (groupId) => {
    editGroupDialog.value = true;
    groupStore.editGroup(groupId);
};
</script>
